// eslint-disable-next-line unicorn/prefer-module
const getProtocol = require('./getProtocol');

const getUrlFromRequest = (request) => `${getProtocol(request)
}://${request.get('host')}${request.originalUrl}`;

// eslint-disable-next-line unicorn/prefer-module
module.exports = getUrlFromRequest;
